var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 339,
    viewBox: "0 0 416 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_6968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.003 293.238H-47.2539V293.49H457.003V293.238Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.476 309.465H373.074V309.717H406.476V309.465Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.787 312.208H278.023V312.46H286.787V312.208Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.064 300.105H352.711V300.357H372.064V300.105Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.21 301.8H5.65234V302.052H49.21V301.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5792 301.8H58.1953V302.052H64.5792V301.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.813 306.056H85.3359V306.308H179.813V306.056Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.772 248.258H-2.97186C-6.14868 248.258 -8.73047 245.676 -8.73047 242.499V-31.2414C-8.73047 -34.4182 -6.14868 -37 -2.97186 -37H191.772C194.949 -37 197.531 -34.4182 197.531 -31.2414V242.499C197.531 245.676 194.949 248.258 191.772 248.258ZM-2.97186 -36.7479C-6.00748 -36.7479 -8.47834 -34.277 -8.47834 -31.2414V242.499C-8.47834 245.535 -6.00748 248.006 -2.97186 248.006H191.772C194.808 248.006 197.279 245.535 197.279 242.499V-31.2414C197.279 -34.277 194.808 -36.7479 191.772 -36.7479H-2.97186Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.917 248.258H215.173C211.996 248.258 209.414 245.676 209.414 242.499V-31.2414C209.414 -34.4182 211.996 -37 215.173 -37H409.917C413.093 -37 415.675 -34.4182 415.675 -31.2414V242.499C415.675 245.676 413.093 248.258 409.917 248.258ZM215.173 -36.7479C212.137 -36.7479 209.666 -34.277 209.666 -31.2414V242.499C209.666 245.535 212.137 248.006 215.173 248.006H409.917C412.952 248.006 415.423 245.535 415.423 242.499V-31.2414C415.423 -34.277 412.952 -36.7479 409.917 -36.7479H215.173Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.264 29.3203H209.301V220.857H380.264V29.3203Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.906 32.4067H209.301V217.459H376.906V32.4067Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.713 130.625V117.625H366.992V108.962H362.04V95.9623H360.81V108.962H355.848V117.625H352.136V130.625H345.329V134.346H342.233V148.587H341.608V128.154H339.752V141.154H337.896V110.203H336.656V123.202H331.704V118.866H329.848V100.914H326.137V82.9525H324.897V85.4334H299.512V78.0007H295.176V49.5203H293.32V78.0007H287.128V85.4334H284.647V122.577H271.647V111.433H275.984V109.577H271.647V106.481H259.263V78.0007H256.166V73.6741H241.311V78.0007H239.455V117.625H232.648V135.587H228.926V121.347H225.83V117.625H219.023V104.625H215.312V95.9623H210.975V82.9525H209.301V217.458H376.906V130.625H370.713Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.747 87.3694H308.992V89.1242H310.747V87.3694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.747 90.3147H308.992V92.0695H310.747V90.3147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.747 102.073H308.992V103.828H310.747V102.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.747 105.018H308.992V106.773H310.747V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.747 107.964H308.992V109.718H310.747V107.964Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.747 116.788H308.992V118.543H310.747V116.788Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.747 119.722H308.992V121.477H310.747V119.722Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.962 99.1394H306.207V100.894H307.962V99.1394Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.962 102.073H306.207V103.828H307.962V102.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.962 105.018H306.207V106.773H307.962V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.962 107.964H306.207V109.718H307.962V107.964Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.962 110.898H306.207V112.653H307.962V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.962 116.788H306.207V118.543H307.962V116.788Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.962 119.722H306.207V121.477H307.962V119.722Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 87.3694H303.414V89.1242H305.169V87.3694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 90.3147H303.414V92.0695H305.169V90.3147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 93.2595H303.414V95.0143H305.169V93.2595Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 96.1941H303.414V97.9489H305.169V96.1941Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 99.1394H303.414V100.894H305.169V99.1394Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 102.073H303.414V103.828H305.169V102.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 105.018H303.414V106.773H305.169V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 107.964H303.414V109.718H305.169V107.964Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 110.898H303.414V112.653H305.169V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 113.843H303.414V115.598H305.169V113.843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.169 119.722H303.414V121.477H305.169V119.722Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 87.3694H300.629V89.1242H302.384V87.3694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 90.3147H300.629V92.0695H302.384V90.3147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 93.2595H300.629V95.0143H302.384V93.2595Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 96.1941H300.629V97.9489H302.384V96.1941Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 99.1394H300.629V100.894H302.384V99.1394Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 102.073H300.629V103.828H302.384V102.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 105.018H300.629V106.773H302.384V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.384 131.492H300.629V133.247H302.384V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 87.3694H297.848V89.1242H299.602V87.3694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 90.3147H297.848V92.0695H299.602V90.3147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 93.2595H297.848V95.0143H299.602V93.2595Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 96.1941H297.848V97.9489H299.602V96.1941Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 99.1394H297.848V100.894H299.602V99.1394Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 102.073H297.848V103.828H299.602V102.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 105.018H297.848V106.773H299.602V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 107.964H297.848V109.718H299.602V107.964Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 125.602H297.848V127.357H299.602V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 128.547H297.848V130.302H299.602V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 131.492H297.848V133.247H299.602V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 134.427H297.848V136.181H299.602V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.602 146.196H297.848V147.951H299.602V146.196Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 87.3694H295.059V89.1242H296.813V87.3694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 90.3147H295.059V92.0695H296.813V90.3147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 93.2595H295.059V95.0143H296.813V93.2595Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 96.1941H295.059V97.9489H296.813V96.1941Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 99.1394H295.059V100.894H296.813V99.1394Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 102.073H295.059V103.828H296.813V102.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 105.018H295.059V106.773H296.813V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 107.964H295.059V109.718H296.813V107.964Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 110.898H295.059V112.653H296.813V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 113.843H295.059V115.598H296.813V113.843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 122.667H295.059V124.422H296.813V122.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 125.602H295.059V127.357H296.813V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 128.547H295.059V130.302H296.813V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 131.492H295.059V133.247H296.813V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 134.427H295.059V136.181H296.813V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.813 146.196H295.059V147.951H296.813V146.196Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 87.3694H292.266V89.1242H294.02V87.3694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 90.3147H292.266V92.0695H294.02V90.3147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 93.2595H292.266V95.0143H294.02V93.2595Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 96.1941H292.266V97.9489H294.02V96.1941Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 99.1394H292.266V100.894H294.02V99.1394Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 102.073H292.266V103.828H294.02V102.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 105.018H292.266V106.773H294.02V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 107.964H292.266V109.718H294.02V107.964Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 110.898H292.266V112.653H294.02V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 113.843H292.266V115.598H294.02V113.843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 116.788H292.266V118.543H294.02V116.788Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 119.722H292.266V121.477H294.02V119.722Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 122.667H292.266V124.422H294.02V122.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 125.602H292.266V127.357H294.02V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 128.547H292.266V130.302H294.02V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 131.492H292.266V133.247H294.02V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 134.427H292.266V136.181H294.02V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.02 137.372H292.266V139.127H294.02V137.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 87.3694H289.484V89.1242H291.239V87.3694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 90.3147H289.484V92.0695H291.239V90.3147Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 93.2595H289.484V95.0143H291.239V93.2595Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 96.1941H289.484V97.9489H291.239V96.1941Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 99.1394H289.484V100.894H291.239V99.1394Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 102.073H289.484V103.828H291.239V102.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 105.018H289.484V106.773H291.239V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 107.964H289.484V109.718H291.239V107.964Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 110.898H289.484V112.653H291.239V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 113.843H289.484V115.598H291.239V113.843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 122.667H289.484V124.422H291.239V122.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 125.602H289.484V127.357H291.239V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 128.547H289.484V130.302H291.239V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.239 131.492H289.484V133.247H291.239V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 87.3694H286.699V89.1242H288.454V87.3694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 90.3145H286.699V92.0693H288.454V90.3145Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 93.2595H286.699V95.0143H288.454V93.2595Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 96.1941H286.699V97.9489H288.454V96.1941Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 99.1392H286.699V100.894H288.454V99.1392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 102.074H286.699V103.829H288.454V102.074Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 105.018H286.699V106.773H288.454V105.018Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 107.964H286.699V109.719H288.454V107.964Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 110.898H286.699V112.653H288.454V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 113.843H286.699V115.598H288.454V113.843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 122.667H286.699V124.422H288.454V122.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 125.603H286.699V127.357H288.454V125.603Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.454 128.547H286.699V130.302H288.454V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 79.7351H255.328V81.4899H257.083V79.7351Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 82.6794H255.328V84.4343H257.083V82.6794Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 85.6248H255.328V87.3796H257.083V85.6248Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 88.5598H255.328V90.3146H257.083V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 91.5042H255.328V93.259H257.083V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 94.4392H255.328V96.194H257.083V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 97.3845H255.328V99.1393H257.083V97.3845Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 100.329H255.328V102.084H257.083V100.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 109.143H255.328V110.898H257.083V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.083 112.089H255.328V113.843H257.083V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 79.7351H252.543V81.4899H254.298V79.7351Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 82.6794H252.543V84.4343H254.298V82.6794Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 85.6248H252.543V87.3796H254.298V85.6248Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 88.5598H252.543V90.3146H254.298V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 91.5042H252.543V93.259H254.298V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 94.4392H252.543V96.194H254.298V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 97.3845H252.543V99.1393H254.298V97.3845Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 100.329H252.543V102.084H254.298V100.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.298 112.089H252.543V113.843H254.298V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.513 79.7351H249.758V81.4899H251.513V79.7351Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.513 82.6797H249.758V84.4345H251.513V82.6797Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.513 85.6248H249.758V87.3796H251.513V85.6248Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.513 88.5598H249.758V90.3146H251.513V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.513 91.5042H249.758V93.259H251.513V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.513 94.4392H249.758V96.194H251.513V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.513 97.3843H249.758V99.1391H251.513V97.3843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.513 100.329H249.758V102.084H251.513V100.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 79.7351H246.973V81.4899H248.727V79.7351Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 82.6794H246.973V84.4343H248.727V82.6794Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 85.6248H246.973V87.3796H248.727V85.6248Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 88.5598H246.973V90.3146H248.727V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 91.5042H246.973V93.259H248.727V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 94.4392H246.973V96.194H248.727V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 100.329H246.973V102.084H248.727V100.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 103.264H246.973V105.019H248.727V103.264Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 112.089H246.973V113.843H248.727V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 115.033H246.973V116.788H248.727V115.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 117.968H246.973V119.723H248.727V117.968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 120.912H246.973V122.667H248.727V120.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 123.847H246.973V125.602H248.727V123.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 126.793H246.973V128.548H248.727V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.727 129.737H246.973V131.492H248.727V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 79.7351H244.18V81.4899H245.934V79.7351Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 82.6797H244.18V84.4345H245.934V82.6797Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 85.6248H244.18V87.3796H245.934V85.6248Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 88.5598H244.18V90.3146H245.934V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 91.5042H244.18V93.259H245.934V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 94.4392H244.18V96.194H245.934V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 103.264H244.18V105.019H245.934V103.264Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 106.208H244.18V107.963H245.934V106.208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 109.143H244.18V110.898H245.934V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 112.088H244.18V113.843H245.934V112.088Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 115.033H244.18V116.788H245.934V115.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 117.968H244.18V119.723H245.934V117.968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 120.913H244.18V122.667H245.934V120.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 123.848H244.18V125.602H245.934V123.848Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 126.793H244.18V128.548H245.934V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 129.737H244.18V131.492H245.934V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 132.672H244.18V134.427H245.934V132.672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.934 138.551H244.18V140.306H245.934V138.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 79.7351H241.398V81.4899H243.153V79.7351Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 82.6794H241.398V84.4343H243.153V82.6794Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 85.6248H241.398V87.3796H243.153V85.6248Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 88.5598H241.398V90.3146H243.153V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 91.5042H241.398V93.259H243.153V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 94.4392H241.398V96.194H243.153V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 103.264H241.398V105.019H243.153V103.264Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 106.208H241.398V107.963H243.153V106.208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 109.143H241.398V110.898H243.153V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 112.089H241.398V113.843H243.153V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 120.912H241.398V122.667H243.153V120.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 123.847H241.398V125.602H243.153V123.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 126.793H241.398V128.548H243.153V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 129.737H241.398V131.492H243.153V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 132.672H241.398V134.427H243.153V132.672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 138.551H241.398V140.306H243.153V138.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.153 141.497H241.398V143.252H243.153V141.497Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 107.086H216.113V108.841H217.868V107.086Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 110.021H216.113V111.776H217.868V110.021Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 112.966H216.113V114.72H217.868V112.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 115.911H216.113V117.666H217.868V115.911Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 118.845H216.113V120.6H217.868V118.845Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 121.79H216.113V123.545H217.868V121.79Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 124.725H216.113V126.48H217.868V124.725Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 133.55H216.113V135.304H217.868V133.55Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 136.494H216.113V138.249H217.868V136.494Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.868 139.429H216.113V141.184H217.868V139.429Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.087 107.086H213.332V108.841H215.087V107.086Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.087 110.021H213.332V111.776H215.087V110.021Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.087 112.966H213.332V114.72H215.087V112.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.087 115.911H213.332V117.666H215.087V115.911Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.087 118.845H213.332V120.6H215.087V118.845Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.087 121.79H213.332V123.545H215.087V121.79Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.087 124.725H213.332V126.48H215.087V124.725Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.303 107.086H209.781V108.841H212.303V107.086Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.303 110.021H209.781V111.775H212.303V110.021Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.303 112.966H209.781V114.72H212.303V112.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.303 115.911H209.781V117.665H212.303V115.911Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.303 118.845H209.781V120.6H212.303V118.845Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.303 121.79H209.781V123.545H212.303V121.79Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.303 124.725H209.781V126.48H212.303V124.725Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 110.898H363.777V112.653H365.532V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 113.843H363.777V115.598H365.532V113.843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 116.788H363.777V118.543H365.532V116.788Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 119.722H363.777V121.477H365.532V119.722Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 122.667H363.777V124.422H365.532V122.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 125.602H363.777V127.357H365.532V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 128.547H363.777V130.302H365.532V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 131.492H363.777V133.247H365.532V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 134.427H363.777V136.181H365.532V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 137.372H363.777V139.127H365.532V137.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 140.306H363.777V142.061H365.532V140.306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 143.251H363.777V145.006H365.532V143.251Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 146.196H363.777V147.951H365.532V146.196Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 149.131H363.777V150.886H365.532V149.131Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 152.076H363.777V153.831H365.532V152.076Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 155.01H363.777V156.765H365.532V155.01Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 157.955H363.777V159.71H365.532V157.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 160.9H363.777V162.655H365.532V160.9Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 163.835H363.777V165.59H365.532V163.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.532 166.78H363.777V168.535H365.532V166.78Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 110.898H360.996V112.653H362.751V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 113.843H360.996V115.598H362.751V113.843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 116.788H360.996V118.543H362.751V116.788Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 119.722H360.996V121.477H362.751V119.722Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 122.667H360.996V124.422H362.751V122.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 125.602H360.996V127.357H362.751V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 128.547H360.996V130.302H362.751V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 131.492H360.996V133.247H362.751V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 134.427H360.996V136.181H362.751V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 137.372H360.996V139.127H362.751V137.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 140.306H360.996V142.061H362.751V140.306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 143.251H360.996V145.006H362.751V143.251Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 146.196H360.996V147.951H362.751V146.196Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 149.131H360.996V150.886H362.751V149.131Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 152.076H360.996V153.831H362.751V152.076Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 155.01H360.996V156.765H362.751V155.01Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 157.955H360.996V159.71H362.751V157.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.751 160.9H360.996V162.655H362.751V160.9Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 110.898H358.203V112.653H359.958V110.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 113.843H358.203V115.598H359.958V113.843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 116.788H358.203V118.543H359.958V116.788Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 119.722H358.203V121.477H359.958V119.722Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 122.667H358.203V124.422H359.958V122.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 125.602H358.203V127.357H359.958V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 128.547H358.203V130.302H359.958V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 131.492H358.203V133.247H359.958V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 134.427H358.203V136.181H359.958V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 137.372H358.203V139.127H359.958V137.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 140.306H358.203V142.061H359.958V140.306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 143.251H358.203V145.006H359.958V143.251Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 146.196H358.203V147.951H359.958V146.196Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 149.131H358.203V150.886H359.958V149.131Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 152.076H358.203V153.831H359.958V152.076Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 155.01H358.203V156.765H359.958V155.01Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 157.955H358.203V159.71H359.958V157.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.958 160.9H358.203V162.655H359.958V160.9Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 132.369H374.199V134.124H375.954V132.369Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 135.304H374.199V137.059H375.954V135.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 138.249H374.199V140.004H375.954V138.249Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 141.184H374.199V142.939H375.954V141.184Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 144.129H374.199V145.883H375.954V144.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 147.073H374.199V148.828H375.954V147.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 150.009H374.199V151.763H375.954V150.009Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 152.953H374.199V154.708H375.954V152.953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 155.888H374.199V157.643H375.954V155.888Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 158.833H374.199V160.588H375.954V158.833Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 161.778H374.199V163.532H375.954V161.778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 164.712H374.199V166.467H375.954V164.712Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.954 167.657H374.199V169.412H375.954V167.657Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 132.369H371.414V134.124H373.169V132.369Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 135.304H371.414V137.059H373.169V135.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 138.249H371.414V140.004H373.169V138.249Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 141.184H371.414V142.939H373.169V141.184Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 144.129H371.414V145.883H373.169V144.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 147.073H371.414V148.828H373.169V147.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 150.009H371.414V151.763H373.169V150.009Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 152.953H371.414V154.708H373.169V152.953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 155.888H371.414V157.643H373.169V155.888Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 158.833H371.414V160.588H373.169V158.833Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 161.778H371.414V163.532H373.169V161.778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 164.712H371.414V166.467H373.169V164.712Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.169 167.657H371.414V169.412H373.169V167.657Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 132.369H368.637V134.124H370.392V132.369Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 135.304H368.637V137.059H370.392V135.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 138.249H368.637V140.004H370.392V138.249Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 141.184H368.637V142.939H370.392V141.184Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 144.129H368.637V145.883H370.392V144.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 147.073H368.637V148.828H370.392V147.073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 150.009H368.637V151.763H370.392V150.009Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 152.953H368.637V154.708H370.392V152.953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 155.888H368.637V157.643H370.392V155.888Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 158.833H368.637V160.588H370.392V158.833Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 161.778H368.637V163.532H370.392V161.778Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 164.712H368.637V166.467H370.392V164.712Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 167.657H368.637V169.412H370.392V167.657Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.392 170.592H368.637V172.347H370.392V170.592Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 133.236H353.152V134.991H354.907V133.236Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 136.182H353.152V137.937H354.907V136.182Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 139.126H353.152V140.881H354.907V139.126Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 142.061H353.152V143.816H354.907V142.061Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 145.007H353.152V146.761H354.907V145.007Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 147.951H353.152V149.706H354.907V147.951Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 150.885H353.152V152.64H354.907V150.885Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 153.831H353.152V155.586H354.907V153.831Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 156.765H353.152V158.52H354.907V156.765Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 159.71H353.152V161.465H354.907V159.71Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.907 168.535H353.152V170.29H354.907V168.535Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 133.236H350.367V134.991H352.122V133.236Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 136.182H350.367V137.937H352.122V136.182Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 139.126H350.367V140.881H352.122V139.126Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 142.061H350.367V143.816H352.122V142.061Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 145.007H350.367V146.761H352.122V145.007Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 147.951H350.367V149.706H352.122V147.951Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 150.885H350.367V152.64H352.122V150.885Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 153.831H350.367V155.586H352.122V153.831Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 156.765H350.367V158.52H352.122V156.765Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 165.59H350.367V167.344H352.122V165.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.122 168.535H350.367V170.29H352.122V168.535Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 133.236H347.582V134.991H349.337V133.236Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 136.182H347.582V137.937H349.337V136.182Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 139.126H347.582V140.881H349.337V139.126Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 142.061H347.582V143.816H349.337V142.061Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 145.007H347.582V146.761H349.337V145.007Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 147.951H347.582V149.706H349.337V147.951Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 150.885H347.582V152.64H349.337V150.885Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 153.831H347.582V155.586H349.337V153.831Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 162.655H347.582V164.41H349.337V162.655Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 165.59H347.582V167.344H349.337V165.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.337 168.535H347.582V170.29H349.337V168.535Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 88.5598H321.676V90.3146H323.431V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 91.5042H321.676V93.259H323.431V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 94.4392H321.676V96.194H323.431V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 97.3845H321.676V99.1393H323.431V97.3845Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 100.329H321.676V102.084H323.431V100.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 103.264H321.676V105.019H323.431V103.264Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 106.208H321.676V107.963H323.431V106.208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 109.143H321.676V110.898H323.431V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 112.089H321.676V113.843H323.431V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 115.033H321.676V116.788H323.431V115.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 117.968H321.676V119.723H323.431V117.968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 120.912H321.676V122.667H323.431V120.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 123.847H321.676V125.602H323.431V123.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 126.793H321.676V128.548H323.431V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 129.737H321.676V131.492H323.431V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 132.672H321.676V134.427H323.431V132.672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 135.617H321.676V137.372H323.431V135.617Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 141.497H321.676V143.252H323.431V141.497Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 144.441H321.676V146.196H323.431V144.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 147.376H321.676V149.131H323.431V147.376Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 150.322H321.676V152.076H323.431V150.322Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.431 153.256H321.676V155.01H323.431V153.256Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 88.5598H318.895V90.3146H320.649V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 91.5042H318.895V93.259H320.649V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 94.4392H318.895V96.194H320.649V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 97.3843H318.895V99.1391H320.649V97.3843Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 100.329H318.895V102.084H320.649V100.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 103.264H318.895V105.019H320.649V103.264Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 106.208H318.895V107.963H320.649V106.208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 109.143H318.895V110.898H320.649V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 112.088H318.895V113.843H320.649V112.088Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 115.033H318.895V116.788H320.649V115.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 117.968H318.895V119.723H320.649V117.968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 120.913H318.895V122.667H320.649V120.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 123.848H318.895V125.602H320.649V123.848Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 126.793H318.895V128.548H320.649V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 129.737H318.895V131.492H320.649V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 132.672H318.895V134.427H320.649V132.672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 150.322H318.895V152.076H320.649V150.322Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.649 153.256H318.895V155.01H320.649V153.256Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 88.5598H316.109V90.3146H317.864V88.5598Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 91.5042H316.109V93.259H317.864V91.5042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 94.4392H316.109V96.194H317.864V94.4392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 97.3845H316.109V99.1393H317.864V97.3845Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 100.329H316.109V102.084H317.864V100.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 103.264H316.109V105.019H317.864V103.264Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 106.208H316.109V107.963H317.864V106.208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 109.143H316.109V110.898H317.864V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 112.089H316.109V113.843H317.864V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 115.033H316.109V116.788H317.864V115.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 117.968H316.109V119.723H317.864V117.968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 120.912H316.109V122.667H317.864V120.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 123.847H316.109V125.602H317.864V123.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 126.793H316.109V128.548H317.864V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 129.737H316.109V131.492H317.864V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 132.672H316.109V134.427H317.864V132.672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 138.551H316.109V140.306H317.864V138.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 141.497H316.109V143.252H317.864V141.497Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 144.441H316.109V146.196H317.864V144.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 147.376H316.109V149.131H317.864V147.376Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.864 153.256H316.109V155.01H317.864V153.256Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 125.602H331.793V127.357H333.548V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 128.547H331.793V130.302H333.548V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 131.492H331.793V133.247H333.548V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 134.427H331.793V136.181H333.548V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 137.372H331.793V139.127H333.548V137.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 140.306H331.793V142.061H333.548V140.306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 143.251H331.793V145.006H333.548V143.251Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 149.131H331.793V150.886H333.548V149.131Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 152.076H331.793V153.831H333.548V152.076Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 155.01H331.793V156.765H333.548V155.01Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 157.955H331.793V159.71H333.548V157.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 160.9H331.793V162.655H333.548V160.9Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 163.835H331.793V165.59H333.548V163.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 166.78H331.793V168.535H333.548V166.78Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.548 169.715H331.793V171.47H333.548V169.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 125.602H329.008V127.357H330.763V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 128.547H329.008V130.302H330.763V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 131.492H329.008V133.247H330.763V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 134.427H329.008V136.181H330.763V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 137.372H329.008V139.127H330.763V137.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 140.306H329.008V142.061H330.763V140.306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 149.131H329.008V150.886H330.763V149.131Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 152.076H329.008V153.831H330.763V152.076Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 155.01H329.008V156.765H330.763V155.01Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 157.955H329.008V159.71H330.763V157.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 160.9H329.008V162.655H330.763V160.9Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 163.835H329.008V165.59H330.763V163.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 166.78H329.008V168.535H330.763V166.78Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.763 169.715H329.008V171.47H330.763V169.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 125.602H326.227V127.357H327.981V125.602Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 128.547H326.227V130.302H327.981V128.547Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 131.492H326.227V133.247H327.981V131.492Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 134.427H326.227V136.181H327.981V134.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 137.372H326.227V139.127H327.981V137.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 140.306H326.227V142.061H327.981V140.306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 146.196H326.227V147.951H327.981V146.196Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 149.131H326.227V150.886H327.981V149.131Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 152.076H326.227V153.831H327.981V152.076Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 155.01H326.227V156.765H327.981V155.01Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 157.955H326.227V159.71H327.981V157.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 160.9H326.227V162.655H327.981V160.9Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 163.835H326.227V165.59H327.981V163.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 166.78H326.227V168.535H327.981V166.78Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.981 169.715H326.227V171.47H327.981V169.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 109.143H267.508V110.898H269.263V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 112.089H267.508V113.843H269.263V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 115.033H267.508V116.788H269.263V115.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 117.968H267.508V119.723H269.263V117.968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 120.912H267.508V122.667H269.263V120.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 123.847H267.508V125.602H269.263V123.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 126.793H267.508V128.548H269.263V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 129.737H267.508V131.492H269.263V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 132.672H267.508V134.427H269.263V132.672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 135.617H267.508V137.372H269.263V135.617Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 138.551H267.508V140.306H269.263V138.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 141.497H267.508V143.252H269.263V141.497Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 144.441H267.508V146.196H269.263V144.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 150.322H267.508V152.076H269.263V150.322Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 153.256H267.508V155.01H269.263V153.256Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 156.2H267.508V157.955H269.263V156.2Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 159.146H267.508V160.901H269.263V159.146Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 165.025H267.508V166.78H269.263V165.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 167.96H267.508V169.715H269.263V167.96Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.263 170.905H267.508V172.659H269.263V170.905Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 109.143H264.715V110.898H266.47V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 112.089H264.715V113.843H266.47V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 115.033H264.715V116.788H266.47V115.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 117.968H264.715V119.723H266.47V117.968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 120.912H264.715V122.667H266.47V120.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 123.847H264.715V125.602H266.47V123.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 126.793H264.715V128.548H266.47V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 129.737H264.715V131.492H266.47V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 132.672H264.715V134.427H266.47V132.672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 135.617H264.715V137.372H266.47V135.617Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 138.551H264.715V140.306H266.47V138.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 141.497H264.715V143.252H266.47V141.497Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 144.441H264.715V146.196H266.47V144.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 153.256H264.715V155.01H266.47V153.256Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 156.2H264.715V157.955H266.47V156.2Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 162.08H264.715V163.835H266.47V162.08Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 165.025H264.715V166.78H266.47V165.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 167.96H264.715V169.715H266.47V167.96Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47 170.905H264.715V172.659H266.47V170.905Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 109.143H261.934V110.898H263.688V109.143Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 112.089H261.934V113.843H263.688V112.089Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 115.033H261.934V116.788H263.688V115.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 117.968H261.934V119.723H263.688V117.968Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 120.912H261.934V122.667H263.688V120.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 123.847H261.934V125.602H263.688V123.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 126.793H261.934V128.548H263.688V126.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 129.737H261.934V131.492H263.688V129.737Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 132.672H261.934V134.427H263.688V132.672Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 135.617H261.934V137.372H263.688V135.617Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 138.551H261.934V140.306H263.688V138.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 141.497H261.934V143.252H263.688V141.497Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 144.441H261.934V146.196H263.688V144.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 147.376H261.934V149.131H263.688V147.376Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 153.256H261.934V155.01H263.688V153.256Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 159.146H261.934V160.901H263.688V159.146Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 162.08H261.934V163.835H263.688V162.08Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 165.025H261.934V166.78H263.688V165.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 167.96H261.934V169.715H263.688V167.96Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.688 170.905H261.934V172.659H263.688V170.905Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 125.915H278.855V127.67H280.61V125.915Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 128.86H278.855V130.614H280.61V128.86Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 131.795H278.855V133.549H280.61V131.795Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 134.74H278.855V136.494H280.61V134.74Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 137.675H278.855V139.429H280.61V137.675Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 140.619H278.855V142.374H280.61V140.619Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 149.444H278.855V151.198H280.61V149.444Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 152.378H278.855V154.133H280.61V152.378Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 155.323H278.855V157.078H280.61V155.323Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 158.268H278.855V160.023H280.61V158.268Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 161.203H278.855V162.958H280.61V161.203Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 164.148H278.855V165.903H280.61V164.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 167.093H278.855V168.847H280.61V167.093Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 125.915H276.07V127.67H277.825V125.915Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 128.86H276.07V130.614H277.825V128.86Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 131.795H276.07V133.549H277.825V131.795Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 134.74H276.07V136.494H277.825V134.74Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 137.675H276.07V139.429H277.825V137.675Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 140.619H276.07V142.374H277.825V140.619Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 149.444H276.07V151.198H277.825V149.444Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 152.378H276.07V154.133H277.825V152.378Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 155.323H276.07V157.078H277.825V155.323Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 158.268H276.07V160.023H277.825V158.268Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 161.203H276.07V162.958H277.825V161.203Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 164.148H276.07V165.903H277.825V164.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.825 170.027H276.07V171.782H277.825V170.027Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.78 29.7539H209.301V220.857H212.78V29.7539Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.168 29.7539H265.223V220.857H268.168V29.7539Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.558 29.7539H320.613V220.857H323.558V29.7539Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.24 269.345C32.24 269.345 27.742 259.532 32.8854 249.851C38.0288 240.169 39.5214 237.89 36.2437 235.913C32.9661 233.926 31.4634 243.658 31.4634 243.658C31.4634 243.658 28.7001 236.972 30.9793 229.963C33.2585 222.964 34.6906 211.557 31.5743 210.337C28.458 209.117 30.9793 224.567 28.2765 229.832C28.2765 229.832 26.0073 223.972 25.6342 218.345C25.261 212.717 25.846 203.741 23.3852 201.442C20.9244 199.143 19.3512 200.736 21.7716 213.141C24.192 225.556 24.1718 235.641 24.1718 235.641C24.1718 235.641 18.8368 219.363 15.2465 218.889C11.6663 218.415 11.6663 223.69 14.7322 228.258C17.798 232.827 23.718 241.026 24.6862 245.242C24.6862 245.242 18.8267 232.988 13.5522 236.75C8.27768 240.502 18.1409 247.904 22.5381 250.577C26.9352 253.249 29.9809 270.011 29.9809 270.011L32.24 269.365V269.345Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6763 273.379C28.6763 273.379 33.0532 263.496 27.7989 253.895C22.5445 244.294 21.0216 242.035 24.2791 240.007C27.5366 237.98 29.1503 247.682 29.1503 247.682C29.1503 247.682 31.8329 240.955 29.4629 233.987C27.103 227.018 25.5297 215.642 28.6359 214.371C31.7321 213.1 29.4024 228.591 32.1657 233.815C32.1657 233.815 34.3643 227.915 34.6668 222.288C34.9694 216.66 34.2836 207.685 36.7141 205.345C39.1446 203.005 40.7381 204.578 38.4689 217.023C36.1998 229.469 36.341 239.554 36.341 239.554C36.341 239.554 41.4844 223.196 45.0646 222.671C48.6448 222.147 48.7053 227.411 45.6899 232.03C42.6744 236.649 36.8654 244.929 35.9376 249.155C35.9376 249.155 41.6558 236.821 46.9707 240.492C52.2856 244.163 42.5131 251.716 38.1563 254.449C33.7894 257.193 30.9454 273.994 30.9454 273.994L28.6763 273.379Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8869 266.33H12.6914L15.6262 292.228H45.9623L48.8869 266.33Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.201 264.484C378.332 263.607 381.337 242.902 375.317 235.752C373.985 234.169 372.301 233.342 370.324 233.291C358.192 233.009 356.528 242.751 356.508 242.852L357.94 243.074C358 242.721 359.433 234.471 370.284 234.733C371.857 234.774 373.138 235.409 374.207 236.68C379.804 243.336 376.799 264.061 376.759 264.273L378.191 264.484H378.201Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.937 263.547L380.39 263.496C380.39 263.305 379.906 244.415 389.214 240.512C398.331 236.69 402.436 244.546 402.607 244.889L403.898 244.244C403.848 244.153 399.037 234.834 388.649 239.191C378.423 243.477 378.907 262.74 378.937 263.557V263.547Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.898 265.029C378.898 264.727 378.988 234.855 384.807 226.111C390.405 217.72 399.421 221.673 399.804 221.845L400.399 220.524C400.298 220.473 389.88 215.885 383.597 225.304C377.526 234.401 377.445 263.779 377.445 265.019H378.898V265.029Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.59 234.007C368.59 234.007 373.885 235.964 372.312 240.573C370.738 245.182 353.977 252.776 353.977 252.776C353.977 252.776 346.958 246.342 353.402 235.883C359.846 225.425 368.439 230.71 368.58 234.007H368.59Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07 224.537C385.07 224.537 381.309 224.134 381.611 221.845C381.914 219.555 396.235 213.656 404.686 223.196C404.686 223.196 399.28 232.495 391.454 232.616C383.628 232.737 385.07 224.547 385.07 224.547V224.537Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.934 239.847C388.934 239.847 386.342 237.749 389.136 236.73C391.939 235.712 405.685 235.994 405.827 249.619C405.827 249.619 389.811 252.282 387.835 247.088C385.848 241.904 388.934 239.847 388.934 239.847Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.749 292.229H390.599L393.271 265.029H363.066L365.749 292.229Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.734 268.024H394.602V262.024H361.734V268.024Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.365 42.1379C121.257 42.1379 127.655 35.7398 127.655 27.8473C127.655 19.9548 121.257 13.5566 113.365 13.5566C105.472 13.5566 99.0742 19.9548 99.0742 27.8473C99.0742 35.7398 105.472 42.1379 113.365 42.1379Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.367 40C120.079 40 125.52 34.5591 125.52 27.8474C125.52 21.1357 120.079 15.6948 113.367 15.6948C106.656 15.6948 101.215 21.1357 101.215 27.8474C101.215 34.5591 106.656 40 113.367 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.938 19.5176V28.0093L119.565 24.8224",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.938 19.5176V28.0093L119.565 24.8224",
    stroke: "#E0E0E0",
    strokeWidth: 2.01703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.873 338.782C312.867 338.782 400.413 333.671 400.413 327.366C400.413 321.061 312.867 315.95 204.873 315.95C96.8785 315.95 9.33203 321.061 9.33203 327.366C9.33203 333.671 96.8785 338.782 204.873 338.782Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.251 77.5874H33.0898V181.041H187.251V77.5874Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9139 134.629H63.2143V314.85L52.9375 317.039V318.854H64.727H66.4011H78.1806V317.039L67.9139 314.85V134.629Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.123 314.85V134.629H152.423V314.85L142.156 317.039V318.854H153.936H155.61H167.399V317.039L157.123 314.85Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.251 77.5874H33.0898V181.041H187.251V77.5874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9139 134.629H63.2143V314.85L52.9375 317.039V318.854H64.727H66.4011H78.1806V317.039L67.9139 314.85V134.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.123 314.85V134.629H152.423V314.85L142.156 317.039V318.854H153.936H155.61H167.399V317.039L157.123 314.85Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.797 176.573V82.0449L37.5508 82.0449V176.573H182.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.757 169.876H46.3789V99.5823H47.3874V168.867H171.757V169.876Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.3493 158.207H52.9336V168.363H58.3493V158.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3493 158.207H52.9336V161.162H58.3493V158.207Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.4118 141.96H63.9961V168.353H69.4118V141.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4118 141.96H63.9961V149.645H69.4118V141.96Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.4821 148.052H75.0664V168.363H80.4821V148.052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4821 148.052H75.0664V153.962H80.4821V148.052Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.5446 138.712H86.1289V168.353H91.5446V138.712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5446 138.712H86.1289V147.345H91.5446V138.712Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.603 130.1H97.1875V168.363H102.603V130.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.603 130.1H97.1875V141.244H102.603V130.1Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.677 123.585H108.262V168.363H113.677V123.585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.677 123.585H108.262V136.625H113.677V123.585Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.74 131.119H119.324V168.364H124.74V131.119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.74 131.119H119.324V141.961H124.74V131.119Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.806 129.495H130.391V168.363H135.806V129.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.806 129.495H130.391V140.811H135.806V129.495Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.865 119.571H141.449V168.353H146.865V119.571Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.865 119.571H141.449V133.771H146.865V119.571Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.927 109.577H152.512V168.353H157.927V109.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.927 109.577H152.512V126.691H157.927V109.577Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.998 100.843H163.582V168.363H168.998V100.843Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.998 100.843H163.582V120.499H168.998V100.843Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.149 88.9629H75.0625V91.7565H142.149V88.9629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.349 203.439H114.945L120.321 182.179C120.442 181.715 120.926 181.342 121.42 181.342H152.049C152.533 181.342 152.835 181.715 152.724 182.179L147.349 203.439Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.104 201.664H116.082L120.802 183.017H151.824L147.104 201.664Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M147.104 201.664H116.082L120.802 183.017H151.824L147.104 201.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.229 202.763H100.785V204.115C100.785 204.69 101.249 205.164 101.834 205.164H146.299C146.874 205.164 147.348 204.7 147.348 204.115V202.763H133.229Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M133.229 202.763H100.785V204.115C100.785 204.69 101.249 205.164 101.834 205.164H146.299C146.874 205.164 147.348 204.7 147.348 204.115V202.763H133.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.042 202.764V203.228H112.395V202.764H100.797V204.115C100.797 204.69 101.261 205.164 101.846 205.164H132.192C132.767 205.164 133.241 204.7 133.241 204.115V202.764H118.053H118.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M134.987 194.02H120.121L122.279 185.498H137.145L134.987 194.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.016 185.992H122.16L122.281 185.498H137.147L137.016 185.992Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.319 200.333H125.645L128.64 188.473H149.324L146.319 200.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.143 189.169H128.469L128.64 188.473H149.325L149.143 189.169Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.066 328.445H352.356L343.895 210.661H350.137L357.066 328.445Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M357.066 328.445H352.356L344.308 216.51L343.895 210.853H350.137L350.48 216.51L357.066 328.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M350.48 216.238H344.308L343.895 210.853H350.137L350.48 216.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.921 328.445H220.211L227.129 210.661H233.372L224.921 328.445Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M233.372 210.853L232.959 216.51L224.911 328.445H220.211L226.786 216.51L227.129 210.853H233.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M227.128 210.852H233.371L232.957 216.238H226.785L227.128 210.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.757 328.445H163.047L154.586 210.661H160.829L167.757 328.445Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M167.757 328.445H163.047L154.999 216.51L154.586 210.853H160.829L161.172 216.51L167.757 328.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.172 216.238H154.999L154.586 210.853H160.829L161.172 216.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7058 328.445H40.9961L47.9145 210.661H54.1673L45.7058 328.445Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.1572 210.853L53.7437 216.51L45.6958 328.445H40.9961L47.5716 216.51L47.9145 210.853H54.1572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9132 210.852H54.1559L53.7424 216.238H47.5703L47.9132 210.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9609 207.716H355.086V211.901C355.086 212.849 354.319 213.615 353.371 213.615H44.6855C43.7375 213.615 42.971 212.849 42.971 211.901V207.716H42.9609Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42.9609 207.716H355.086V211.901C355.086 212.849 354.319 213.615 353.371 213.615H44.6855C43.7375 213.615 42.971 212.849 42.971 211.901V207.716H42.9609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.082 207.716H42.957V210.66H355.082V207.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.011 208.482H40.0469C39.1291 208.482 38.3828 207.736 38.3828 206.818C38.3828 205.9 39.1291 205.154 40.0469 205.154H358.011C358.929 205.154 359.675 205.9 359.675 206.818C359.675 207.736 358.929 208.482 358.011 208.482Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M358.011 208.482H40.0469C39.1291 208.482 38.3828 207.736 38.3828 206.818C38.3828 205.9 39.1291 205.154 40.0469 205.154H358.011C358.929 205.154 359.675 205.9 359.675 206.818C359.675 207.736 358.929 208.482 358.011 208.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.441 203.439H285.845L280.469 182.179C280.348 181.715 279.864 181.342 279.37 181.342H248.742C248.258 181.342 247.955 181.715 248.066 182.179L253.441 203.439Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.685 201.664H284.707L279.987 183.017H248.965L253.685 201.664Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M253.685 201.664H284.707L279.987 183.017H248.965L253.685 201.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.561 202.764H300.004V204.115C300.004 204.69 299.541 205.164 298.956 205.164H254.49C253.915 205.164 253.441 204.7 253.441 204.115V202.764H267.561Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M267.561 202.764H300.004V204.115C300.004 204.69 299.541 205.164 298.956 205.164H254.49C253.915 205.164 253.441 204.7 253.441 204.115V202.764H267.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.749 202.764V203.228H288.397V202.764H299.995V204.115C299.995 204.69 299.531 205.164 298.946 205.164H268.6C268.025 205.164 267.551 204.7 267.551 204.115V202.764H282.739H282.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.048 200.303H282.883L278.839 184.328H251.004L255.048 200.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.246 185.266H279.081L278.839 184.328H251.004L251.246 185.266Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.342 320.053L332.3 319.559C332.572 319.529 332.824 319.731 332.854 320.003L333.631 326.276C333.671 326.962 333.157 327.557 332.471 327.607C329.698 327.738 328.356 327.658 324.857 327.849C322.709 327.98 318.473 328.434 315.508 328.152C312.543 327.869 312.906 324.945 314.187 324.803C317.222 324.461 321.246 322.232 323.142 320.537C323.475 320.245 323.899 320.074 324.332 320.053H324.342Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.823 320.053L291.78 319.559C292.052 319.529 292.305 319.731 292.335 320.003L293.111 326.276C293.152 326.962 292.637 327.557 291.952 327.607C289.178 327.738 287.837 327.658 284.337 327.849C282.189 327.98 277.953 328.434 274.988 328.152C272.023 327.869 272.386 324.945 273.667 324.803C276.703 324.461 280.727 322.232 282.623 320.537C282.956 320.245 283.379 320.074 283.813 320.053H283.823Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.683 200.121L307.148 201.1C307.148 201.1 304.929 200.363 302.59 200.121C300.25 199.879 297.537 200.121 297.537 200.121C297.537 200.121 294.582 201.231 294.582 204.065C294.582 204.065 301.48 205.91 304.133 204.801L313.683 204.065V200.121Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.186 175.211C325.121 179.417 322.348 195.684 321.612 196.794C320.875 197.903 306.827 199.94 306.827 199.94C306.827 199.94 305.344 203.016 306.827 205.548C306.827 205.548 324.234 204.751 326.352 203.641C328.459 202.532 333.643 190.39 333.643 190.39C333.643 190.39 334.137 187.193 332.957 182.019C331.788 176.845 329.196 175.232 329.196 175.232L329.186 175.211Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M329.186 175.211C325.121 179.417 322.348 195.684 321.612 196.794C320.875 197.903 306.827 199.94 306.827 199.94C306.827 199.94 305.344 203.016 306.827 205.548C306.827 205.548 324.234 204.751 326.352 203.641C328.459 202.532 333.643 190.39 333.643 190.39C333.643 190.39 334.137 187.193 332.957 182.019C331.788 176.845 329.196 175.232 329.196 175.232L329.186 175.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.303 152.812C298.303 152.812 297.436 155.202 296.316 156.685C296.316 156.685 297.204 157.744 298.696 157.34L298.303 152.812Z",
    fill: "#D58745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.204 151.653C297.284 152.359 297.728 152.883 298.202 152.823C298.666 152.772 298.989 152.157 298.898 151.451C298.817 150.745 298.374 150.221 297.91 150.281C297.446 150.332 297.123 150.947 297.204 151.653Z",
    fill: "#2E353A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.379 148.858C297.379 148.858 297.893 148.717 298.519 149.262",
    stroke: "#2E353A",
    strokeWidth: 0.726129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.152 160.719C300.324 161.031 300.495 161.324 300.687 161.606C301.827 163.3 303.42 164.541 305.185 165.237C305.649 165.428 306.123 165.57 306.607 165.691C309.159 166.286 311.902 165.822 314.06 164.158C314.947 163.492 315.744 162.595 316.379 161.505C318.921 157.199 317.822 153.256 316.511 146.428C316.248 144.956 315.653 143.564 314.756 142.374C311.619 138.168 305.659 137.311 301.464 140.448C295.544 144.804 297.167 155.041 300.163 160.729L300.152 160.719Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M305.18 165.237C305.644 165.429 306.118 165.57 306.602 165.691C309.153 166.286 311.896 165.822 314.055 164.158C313.248 162.978 312.28 162.181 312.28 162.181C312.28 162.181 308.104 162.574 305.18 165.247V165.237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.746 169.967C322.194 173.82 309.971 175.332 309.971 175.332C309.971 175.332 304.555 175.221 305.221 173.376C308.085 172.125 309.174 170.37 309.325 168.434C309.406 167.305 309.164 166.125 308.771 164.945C308.569 164.319 308.307 163.704 308.035 163.109L316.193 153.145C314.065 164.158 320.611 167.234 324.756 169.977L324.746 169.967Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.273 140.034C300.583 136.404 302.64 137.039 302.64 137.039C304.112 133.993 312.776 133.872 317.173 136.867C321.57 139.863 323.103 145.47 322.81 149.928C322.387 156.412 318.322 163.008 318.322 163.008C313.209 164.37 308.913 163.25 308.59 160.537C308.257 157.824 305.524 155.817 305.524 155.817C303.003 156.665 300.724 153.861 300.724 153.861C300.724 153.861 297.87 151.34 298.636 147.85C299.403 144.361 296.337 143.08 298.283 140.014L298.273 140.034Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.419 154.042C306.389 155.605 305.855 156.886 304.937 157.592C303.717 158.52 302.325 156.816 302.012 154.748C301.75 152.913 302.032 150.149 303.585 150.109C305.139 150.069 306.44 152.106 306.419 154.042Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.957 154.153C301.957 154.153 302.653 160.033 304.236 162.372C305.82 164.712 305.628 165.509 307.796 165.882C307.796 165.882 306.576 167.506 305.477 167.274C304.377 167.042 304.63 166.114 303.651 166.124C302.683 166.144 300.999 165.469 301.18 164.46C301.362 163.452 301.543 163.179 300.263 162.312C298.982 161.445 298.528 159.488 299.224 158.671C299.92 157.854 301.241 158.106 301.241 158.106L301.14 153.729L301.967 154.153H301.957Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.418 173.375C307.418 173.375 309.395 164.51 321.285 164.601L324.3 168.988L307.418 173.375Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M307.418 173.375C307.418 173.375 309.395 164.51 321.285 164.601L324.3 168.988L307.418 173.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.406 283.051C313.914 300.176 321.014 322.262 321.014 322.262L333.479 321.314C333.479 321.314 326.712 291.513 324.856 273.218C323.706 261.923 323.807 252.584 327.115 251.858C329.193 251.404 334.064 251.414 340.307 251.566V228.319C322.799 231.91 305.382 238.697 304.061 244.133C302.205 251.787 305.442 267.994 309.416 283.061L309.406 283.051Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M309.406 283.051C314.065 280.106 319.511 276.637 324.856 273.208C323.706 261.913 323.807 252.574 327.115 251.848C329.193 251.394 334.064 251.404 340.307 251.555V228.309C322.799 231.899 305.382 238.687 304.061 244.123C302.205 251.777 305.442 267.984 309.416 283.051H309.406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.539 221.391L313.574 212.435C313.574 212.435 311.446 195.845 300.625 174.949C300.625 174.949 313.645 165.701 328.077 167.083C339.18 168.142 349.629 196.612 352.896 219.142L316.539 221.381V221.391Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M352.895 219.142L316.538 221.391L313.563 212.436C313.563 212.436 313.2 209.602 312.009 204.791C311.183 201.493 309.972 197.248 308.207 192.356C306.352 187.183 303.881 181.263 300.613 174.949C300.613 174.949 313.633 165.711 328.065 167.083C339.179 168.142 349.627 196.602 352.895 219.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.236 226.02L315.137 217.195L350.808 211.326C350.808 211.326 362.476 234.441 356.768 245.777C351.534 256.175 295.773 249.982 287.191 251.858C278.517 253.754 293.03 321.163 293.03 321.163L280.565 322.111C280.565 322.111 260.173 260.471 264.136 244.123C265.861 236.993 295.259 227.553 316.236 226.02Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.119 215.34L335.589 217.508L335.055 215.068L351.614 212.657L352.119 215.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.667 215.088L333.869 217.508L318.59 219.606V217.216L333.667 215.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.646 217.346V219.606L315.438 219.908V217.72L317.646 217.346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.009 205.578C311.182 202.431 309.972 198.387 308.207 193.728C308.842 192.417 309.71 191.257 310.819 190.379C310.819 190.379 314.238 201.503 312.009 205.578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.116 202.622L277.609 201.735C277.609 201.735 275.39 200.999 273.051 200.757C270.711 200.514 267.998 200.757 267.998 200.757C267.998 200.757 265.043 201.866 265.043 204.7C265.043 204.7 271.941 206.545 274.594 205.436L282.712 207.272L283.116 202.612V202.622Z",
    fill: "#EBB376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.616 175.211C298.044 178.035 299.547 201.13 298.71 202.713C297.873 204.296 278.63 201.099 278.63 201.099L277.359 206.818C277.359 206.818 299.98 213.464 304.125 213.545C308.27 213.625 310.802 189.149 310.802 189.149C310.802 189.149 310.227 185.74 307.191 181.403C304.156 177.057 300.606 175.221 300.606 175.221L300.616 175.211Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M300.616 175.211C298.044 178.035 299.547 201.13 298.71 202.713C297.873 204.296 278.63 201.099 278.63 201.099L277.359 206.818C277.359 206.818 299.98 213.464 304.125 213.545C308.27 213.625 310.802 189.149 310.802 189.149C310.802 189.149 310.227 185.74 307.191 181.403C304.156 177.057 300.606 175.221 300.606 175.221L300.616 175.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.988 255.771H296.322V251.273C296.322 247.492 299.388 244.426 303.17 244.426H360.13C363.912 244.426 366.978 247.492 366.978 251.273V255.771H366.988Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M366.988 255.771H296.322V251.273C296.322 247.492 299.388 244.426 303.17 244.426H360.13C363.912 244.426 366.978 247.492 366.978 251.273V255.771H366.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.808 216.328H304.9C302.903 216.328 301.42 218.496 301.864 220.766L308.823 255.771H310.426L304.496 225.092C304.063 222.823 305.535 220.675 307.532 220.675H343.001L343.798 216.328H343.808Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.117 257.001V286.581C327.117 287.539 327.894 288.296 328.842 288.296H336.093C337.051 288.296 337.818 287.529 337.818 286.581V257.001H327.127H327.117Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.295 328.444C372.033 328.444 373.442 327.036 373.442 325.298C373.442 323.56 372.033 322.151 370.295 322.151C368.557 322.151 367.148 323.56 367.148 325.298C367.148 327.036 368.557 328.444 370.295 328.444Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M368.719 325.298C368.719 324.431 369.425 323.725 370.292 323.725C371.159 323.725 371.865 324.431 371.865 325.298C371.865 326.165 371.159 326.871 370.292 326.871C369.425 326.871 368.719 326.165 368.719 325.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 325.298C291.5 323.563 292.912 322.151 294.647 322.151C296.381 322.151 297.793 323.563 297.793 325.298C297.793 327.033 296.381 328.444 294.647 328.444C292.912 328.444 291.5 327.033 291.5 325.298Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M293.07 325.298C293.07 324.431 293.776 323.725 294.644 323.725C295.511 323.725 296.217 324.431 296.217 325.298C296.217 326.165 295.511 326.871 294.644 326.871C293.776 326.871 293.07 326.165 293.07 325.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.865 311.511V277.706H335.069V311.511C355.319 312.026 367.623 319.106 370.084 320.659C370.366 320.84 370.538 321.153 370.538 321.496V324.309C370.538 324.854 370.094 325.308 369.539 325.308C369.187 325.308 368.854 325.116 368.672 324.804L367.472 322.696C367.472 322.696 353.544 317.734 335.058 317.331V322.887C335.058 323.593 334.484 324.178 333.778 324.178H331.145C330.439 324.178 329.855 323.604 329.855 322.887V317.331C311.368 317.734 297.441 322.696 297.441 322.696L296.241 324.804C296.059 325.116 295.737 325.308 295.373 325.308C294.829 325.308 294.375 324.864 294.375 324.309V321.496C294.375 321.153 294.546 320.84 294.829 320.659C297.29 319.106 309.593 312.026 329.844 311.511H329.865Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.767 328.435H334.176V322.152H330.767V328.435Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M337.807 257.001H327.117V269.295H337.807V257.001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.391 253.956V257.485C294.391 258.484 295.086 259.291 295.944 259.291H367.367C368.224 259.291 368.92 258.484 368.92 257.485V253.956C368.92 252.967 368.234 252.15 367.367 252.15H295.944C295.086 252.15 294.391 252.967 294.391 253.956Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.252 255.771H368.914C368.914 255.771 382.156 234.028 382.156 198.104V184.913C382.156 179.497 377.698 175.1 372.202 175.1H354.533C349.147 175.1 344.74 179.326 344.589 184.641C344.074 203.147 341.311 243.235 327.242 255.781L327.252 255.771Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M336.415 255.771H367.034C368.214 255.771 369.303 255.126 369.847 254.087C372.863 248.348 382.151 228.198 382.151 198.104V184.913C382.151 179.487 377.704 175.1 372.207 175.1H356.939C351.553 175.1 347.146 179.326 346.995 184.641C346.541 201.18 344.282 234.935 333.773 250.89C332.381 252.998 333.864 255.781 336.405 255.781L336.415 255.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.391 253.956V257.485C294.391 258.484 295.086 259.291 295.944 259.291H327.954C329.114 259.291 330.052 258.201 330.052 256.85V254.591C330.052 253.24 329.114 252.15 327.954 252.15H295.954C295.097 252.15 294.401 252.967 294.401 253.956H294.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.139 178.499L101.083 179.225L100.377 176.764C100.377 176.764 99.4693 177.369 98.2188 176.764C97.8759 176.603 97.4019 176.31 96.8775 175.967C95.516 175.07 93.9023 173.839 93.9023 173.839L96.2623 169.029C96.2623 169.029 97.2909 169.442 98.5516 169.997C100.327 170.794 102.555 171.853 102.949 172.417C103.614 173.376 103.282 175.161 103.282 175.161L104.139 178.499Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.8775 175.967C95.516 175.07 93.9023 173.839 93.9023 173.839L96.2623 169.029C96.2623 169.029 97.2909 169.442 98.5516 169.997C98.6625 171.409 98.5516 173.88 96.8775 175.967Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.341 289.586L141.288 291.573L137.648 284.715L134.34 278.473L139.947 275.114L143.336 282.769L146.341 289.586Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.336 282.769L137.648 284.715L134.34 278.473L139.947 275.114L143.336 282.769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.287 279.027L135.399 282.718C135.399 282.718 109.39 236.982 105.386 237.365C101.382 237.749 63.4419 261.933 51.8641 252.997C40.2965 244.072 51.5515 217.175 51.5515 217.175C51.5515 217.175 75.4936 210.337 78.0855 215.592C78.5897 216.61 79.2654 218.647 79.7999 220.402C80.3143 222.046 80.6975 223.438 80.6975 223.438C80.6975 223.438 80.6975 223.438 80.7076 223.428C81.4337 223.135 105.083 213.433 115.632 218.637C126.353 223.922 142.267 279.027 142.267 279.027H142.287Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M142.287 279.027L135.399 282.718C135.399 282.718 109.39 236.982 105.386 237.365C101.382 237.749 63.4419 261.933 51.8641 252.997C40.2965 244.072 51.5515 217.175 51.5515 217.175C51.5515 217.175 75.4936 210.337 78.0855 215.592C78.5897 216.61 79.2654 218.647 79.7999 220.402C80.3143 222.046 80.6975 223.438 80.6975 223.438C80.6975 223.438 80.6975 223.438 80.7076 223.428C81.4337 223.135 105.083 213.433 115.632 218.637C126.353 223.922 142.267 279.027 142.267 279.027H142.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.893 316.322L99.4974 315.707L99.4671 308.093L99.457 301.104L105.982 300.791L105.407 309.02L104.893 316.322Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.385 309.182L99.4453 308.234V301.174L105.98 300.831L105.385 309.182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.027 280.449L142.102 275.406L143.151 279.672L135.527 283.605L132.027 280.449Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7422 253.078C69.7422 253.078 71.4062 252.887 96.851 248.177C96.851 248.177 97.4259 280.722 98.6361 304.976L106.472 305.228C106.472 305.228 117.717 251.384 116.396 243.255C115.075 235.127 105.403 234.027 105.403 234.027C105.403 234.027 88.6014 247.078 69.7523 253.078H69.7422Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M69.7422 253.078C69.7422 253.078 71.4062 252.887 96.851 248.177C96.851 248.177 97.4259 280.722 98.6361 304.976L106.472 305.228C106.472 305.228 117.717 251.384 116.396 243.255C115.075 235.127 105.403 234.027 105.403 234.027C105.403 234.027 88.6014 247.078 69.7523 253.078H69.7422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M69.7422 253.078C69.7422 253.078 71.4062 252.887 96.851 248.177C96.851 248.177 97.4259 280.722 98.6361 304.976L106.472 305.228C106.472 305.228 117.717 251.384 116.396 243.255C115.075 235.127 105.403 234.027 105.403 234.027C105.403 234.027 88.6014 247.078 69.7523 253.078H69.7422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1953 302.808L107.886 302.556L106.423 306.963L97.75 307.044L97.1953 302.808Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.403 298.562C155.556 298.31 154.668 298.209 153.791 298.269C153.791 298.269 150.523 296.908 146.58 290.413L143.211 290.857C142.052 291.028 141.114 291.916 140.882 293.065C140.851 293.227 140.841 293.388 140.851 293.55C140.993 294.356 141.194 295.153 141.446 295.94C142.092 298.421 144.502 303.594 144.502 303.594L145.057 303.372L143.332 298.491C142.758 296.827 144.775 298.229 145.844 299.843C146.913 301.446 148.425 303.009 152.026 301.648C156.221 300.034 157.885 299.177 156.413 298.582L156.403 298.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.718 288.679C145.718 288.679 151.134 296.898 153.786 298.27C153.786 298.27 150.811 300.65 146.838 296.807C141.704 291.835 140.847 293.54 140.847 293.54C140.847 293.54 140.766 291.603 140.978 290.625C141.392 288.739 145.718 288.679 145.718 288.679Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.969 325.893C112.213 325.439 111.376 325.137 110.498 324.986C110.498 324.986 107.644 322.888 105.355 315.637L101.977 315.263C100.807 315.153 99.6872 315.788 99.1829 316.857C99.1123 316.998 99.0619 317.159 99.0417 317.311C98.9913 318.128 98.9913 318.955 99.0417 319.772C99.0821 322.333 100.202 327.93 100.202 327.93L100.786 327.84L100.262 322.686C100.091 320.931 101.724 322.777 102.38 324.592C103.035 326.408 104.135 328.283 107.957 327.809C112.415 327.245 114.23 326.791 112.949 325.873L112.969 325.893Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.93 313.761C104.93 313.761 108.238 323.029 110.497 324.985C110.497 324.985 107.038 326.589 104.093 321.919C100.281 315.868 99.0508 317.321 99.0508 317.321C99.0508 317.321 99.434 315.425 99.8778 314.527C100.725 312.792 104.94 313.761 104.94 313.761H104.93Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7409 158.964C98.7409 158.964 96.8751 158.913 96.0078 160.244",
    stroke: "#263238",
    strokeWidth: 0.504257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9219 163.401C97.9219 163.401 99.0111 165.015 100.11 165.922C100.11 165.922 99.6464 166.87 98.4665 166.84L97.932 163.401H97.9219Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.866 161.495C98.9366 162.03 98.7047 162.504 98.3416 162.544C97.9886 162.595 97.6357 162.191 97.5751 161.657C97.5045 161.122 97.7365 160.648 98.0996 160.608C98.4526 160.557 98.8055 160.961 98.866 161.495Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9492 160.648L99.0586 160.043C99.0586 160.043 98.6048 161.102 97.9492 160.648Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9388 174.343C85.0094 174.394 85.08 174.454 85.1606 174.485C86.1893 175.14 87.3693 175.765 88.6803 175.997C92.3614 176.663 94.8222 176.038 96.3551 174.313C98.5033 171.731 98.8562 167.334 98.2814 162.08C98.0192 159.67 97.5754 157.582 96.8291 155.978C96.8291 155.958 96.8191 155.898 96.809 155.888C96.7686 155.827 96.7485 155.736 96.7081 155.666C95.5987 153.427 93.8742 152.025 91.2016 151.531C90.2738 151.359 89.235 151.289 88.0651 151.329C77.7783 151.722 76.7597 168.847 84.9287 174.333L84.9388 174.343Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.1641 174.495C86.1927 175.15 87.3626 175.634 88.6737 175.866C92.3548 176.532 94.8054 175.786 96.3485 174.041C94.5836 174.525 92.1833 174.787 89.8032 173.829C88.3005 173.224 86.6768 173.648 85.1641 174.505V174.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8395 155.918C96.8395 155.918 97.7572 163.098 91.0708 166.537C91.0708 166.537 88.499 174.172 84.1826 174.484C78.303 174.918 72.6956 166.789 74.3193 158.157C76.4271 146.962 93.1483 145.238 96.8294 155.918H96.8395Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4375 164.289C94.377 163.159 93.3785 161.314 91.6439 161.657C89.8487 162.01 89.0621 166.518 93.5601 167.304C94.2055 167.415 94.5585 166.639 94.4375 164.289Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9092 148.858C83.9092 148.858 90.7066 146.781 94.6398 149.362C99.2386 152.378 101.084 155.635 96.082 161.081C96.082 161.081 84.3429 157.905 80.5509 158.883C76.7488 159.861 74.0561 161.122 74.0561 161.122C72.8761 153.528 79.9962 147.497 83.9092 148.868V148.858Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3645 175.301C90.3645 175.301 85.3119 177.772 86.7843 183.188L73.9258 177.833C73.9258 177.833 80.9551 177.389 80.592 172.447C80.592 172.447 87.9441 169.623 90.3645 175.301Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6671 150.25C85.6671 150.25 81.8348 139.197 73.1212 141.103C64.4177 143.009 65.0834 152.358 71.316 155.242C77.5385 158.137 86.2621 157.037 85.6671 150.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7163 155.071C73.7163 155.071 66.0314 155.021 66.9795 161.616C66.9795 161.616 67.6451 159.478 69.3696 158.601C69.3696 158.601 67.04 160.386 69.3595 163.462C69.3595 163.462 68.4317 161.455 71.6085 160.053C74.7853 158.651 83.4787 158.782 81.8651 154.486C80.2414 150.19 73.7163 155.071 73.7163 155.071Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3049 150.24C84.3049 150.24 82.4493 136.787 71.5977 139.5",
    stroke: "#263238",
    strokeWidth: 0.504257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9861 170.048C79.9861 170.048 72.0692 166.044 73.4711 159.71",
    stroke: "#263238",
    strokeWidth: 0.504257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9281 155.121C72.9281 155.121 65.9896 155.01 65.3945 159.74",
    stroke: "#263238",
    strokeWidth: 0.504257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8164 177.47L77.9529 175.21C77.9529 175.21 88.2801 176.612 88.3809 183.188C88.4818 189.763 74.8164 177.47 74.8164 177.47Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9322 177.47C72.9322 177.47 80.6776 175.978 91.4485 183.188C91.4485 183.188 95.0589 198.962 79.8102 220.413L50.9062 218.597C50.9062 218.597 58.7323 187.011 72.9322 177.47Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.708 223.448L70.875 228.39C70.875 228.39 74.1325 222.944 79.8205 220.413C80.3349 222.056 80.7181 223.448 80.7181 223.448H80.708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M90.5711 197.731C90.087 199.758 89.4214 201.967 88.5339 204.316C86.7286 209.127 83.9754 214.553 79.8102 220.412L50.9062 218.597C50.9062 218.597 58.7323 187.01 72.9322 177.47C72.9322 177.47 80.6675 175.987 91.4485 183.188C91.4485 183.188 92.7192 188.745 90.5711 197.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90.5683 197.731C90.0842 199.759 89.4186 201.967 88.5311 204.317C88.2184 200.878 88.5916 197.177 88.5916 197.177C89.3379 197.257 89.9934 197.449 90.5683 197.731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4486 183.189C91.4486 183.189 99.9504 195.412 102.149 196.582C104.348 197.752 100.122 177.471 100.122 177.471L104.226 176.583C104.226 176.583 111.498 200.969 106.617 205.164C101.735 209.36 88.6046 197.187 88.6046 197.187C88.6046 197.187 88.1407 192.396 88.6046 188.806C89.0685 185.216 91.4587 183.199 91.4587 183.199L91.4486 183.189Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M91.4486 183.189C91.4486 183.189 99.9504 195.412 102.149 196.582C104.348 197.752 100.122 177.471 100.122 177.471L104.226 176.583C104.226 176.583 111.498 200.969 106.617 205.164C101.735 209.36 88.6046 197.187 88.6046 197.187C88.6046 197.187 88.1407 192.396 88.6046 188.806C89.0685 185.216 91.4587 183.199 91.4587 183.199L91.4486 183.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8305 244.425H91.7914C95.5733 244.425 98.6392 247.491 98.6392 251.273V255.771H27.9727V251.273C27.9727 247.491 31.0385 244.425 34.8205 244.425H34.8305Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.8305 244.425H91.7914C95.5733 244.425 98.6392 247.491 98.6392 251.273V255.771H27.9727V251.273C27.9727 247.491 31.0385 244.425 34.8205 244.425H34.8305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1562 216.328H90.0647C92.0615 216.328 93.5441 218.496 93.1003 220.765L86.1416 255.771H84.538L90.4681 225.092C90.9018 222.822 89.4293 220.674 87.4325 220.674H51.9631L51.1663 216.328H51.1562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8488 257.001V286.581C67.8488 287.539 67.0722 288.295 66.1242 288.295H58.873C57.9149 288.295 57.1484 287.529 57.1484 286.581V257.001H67.8387H67.8488Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8205 325.297C27.8205 323.562 26.4085 322.15 24.6739 322.15C22.9393 322.15 21.5273 323.562 21.5273 325.297C21.5273 327.032 22.9393 328.444 24.6739 328.444C26.4085 328.444 27.8205 327.032 27.8205 325.297Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.2442 325.297C26.2442 324.43 25.5383 323.724 24.6709 323.724C23.8036 323.724 23.0977 324.43 23.0977 325.297C23.0977 326.164 23.8036 326.87 24.6709 326.87C25.5383 326.87 26.2442 326.164 26.2442 325.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.473 325.297C103.473 323.562 102.061 322.15 100.326 322.15C98.5916 322.15 97.1797 323.562 97.1797 325.297C97.1797 327.032 98.5916 328.444 100.326 328.444C102.061 328.444 103.473 327.032 103.473 325.297Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.323 326.87C101.192 326.87 101.897 326.166 101.897 325.297C101.897 324.428 101.192 323.724 100.323 323.724C99.4544 323.724 98.75 324.428 98.75 325.297C98.75 326.166 99.4544 326.87 100.323 326.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.103 311.511V277.706H59.8991V311.511C39.6482 312.025 27.3443 319.105 24.8835 320.658C24.6011 320.84 24.4297 321.152 24.4297 321.495V324.309C24.4297 324.854 24.8734 325.307 25.4281 325.307C25.7811 325.307 26.1139 325.116 26.2954 324.803L27.4956 322.695C27.4956 322.695 41.4231 317.733 59.9092 317.33V322.887C59.9092 323.593 60.484 324.178 61.2001 324.178H63.8323C64.5383 324.178 65.1131 323.603 65.1131 322.887V317.33C83.5992 317.733 97.5267 322.695 97.5267 322.695L98.7269 324.803C98.9084 325.116 99.2311 325.307 99.5942 325.307C100.139 325.307 100.593 324.864 100.593 324.309V321.495C100.593 321.152 100.421 320.84 100.139 320.658C97.678 319.105 85.3741 312.025 65.1232 311.511H65.103Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2056 322.161H60.7969V328.444H64.2056V322.161Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.8465 257.001H57.1562V269.295H67.8465V257.001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.572 253.955V257.485C100.572 258.483 99.8762 259.29 99.019 259.29H27.5961C26.7388 259.29 26.043 258.483 26.043 257.485V253.955C26.043 252.967 26.7288 252.15 27.5961 252.15H99.019C99.8762 252.15 100.572 252.967 100.572 253.955Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.716 255.771H26.0543C26.0543 255.771 12.8125 234.027 12.8125 198.104V184.912C12.8125 179.497 17.2701 175.1 22.7665 175.1H40.4357C45.8211 175.1 50.2283 179.325 50.3796 184.64C50.894 203.146 53.6573 243.235 67.726 255.781L67.716 255.771Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.5486 255.771H27.9301C26.7502 255.771 25.661 255.125 25.1164 254.086C22.1009 248.348 12.8125 228.198 12.8125 198.104V184.912C12.8125 179.487 17.26 175.1 22.7564 175.1H38.0253C43.4108 175.1 47.818 179.325 47.9693 184.64C48.4231 201.18 50.6822 234.935 61.1909 250.889C62.5826 252.997 61.1001 255.781 58.5587 255.781L58.5486 255.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.575 253.955V257.485C100.575 258.483 99.8792 259.29 99.022 259.29H67.0118C65.852 259.29 64.9141 258.201 64.9141 256.85V254.591C64.9141 253.239 65.852 252.15 67.0118 252.15H99.0119C99.8691 252.15 100.565 252.967 100.565 253.955H100.575Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_6968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 339,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyName);
export default __webpack_public_path__ + "static/media/companyName.e5d90ba277c54f03490a88a90e5a68e4.svg";
export { ForwardRef as ReactComponent };